import { Typography } from '@mui/material';
import { Modal } from '@components/Modal';

type UnlockConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  title: string;
  message: string;
  cancelText: string;
  confirmText: string;
};

export const UnlockConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  title,
  message,
  cancelText,
  confirmText
}: UnlockConfirmationDialogProps) => {
  return (
    <Modal open={open} onClose={onClose} width="400px">
      <Modal.Header title={title} onClose={onClose} />
      <Modal.Content>
        <Typography variant="body1">{message}</Typography>
      </Modal.Content>
      <Modal.Footer
        secondaryButton={{
          text: cancelText,
          onClick: onClose,
          variant: 'text',
          disabled: isLoading
        }}
        primaryButton={{
          text: confirmText,
          onClick: onConfirm,
          color: 'error',
          variant: 'contained',
          disabled: isLoading
        }}
      />
    </Modal>
  );
};
